import { autoUpdate, flip, shift, useFloating } from "@floating-ui/react";
import { PropsWithChildren, RefObject } from "react";
import { createPortal } from "react-dom";

import css from "./popover.module.scss";

type PopoverProps = PropsWithChildren<{
  reference: RefObject<HTMLDivElement | null>;
  portalRef?: RefObject<HTMLElement | null>;
  qaId?: string;
}>;

export const Popover = ({ children, reference, portalRef, qaId }: PopoverProps) => {
  const { refs, floatingStyles } = useFloating({
    strategy: "fixed",
    placement: "bottom-start",
    whileElementsMounted: autoUpdate,
    elements: { reference: reference.current },
    middleware: [
      flip(),
      shift({
        mainAxis: true, // Prevents horizontal clipping (left/right overflow)
        crossAxis: true // Prevents vertical clipping by shifting over the reference element
      })
    ]
  });

  const FloatingElement = (
    <div
      ref={refs.setFloating}
      className={css.root}
      style={{
        ...floatingStyles,
        minWidth: reference.current?.offsetWidth
      }}
      data-popover="true"
      data-qa-id={qaId}
    >
      {children}
    </div>
  );

  return portalRef?.current ? createPortal(FloatingElement, portalRef.current) : FloatingElement;
};
